import { useMemo } from 'react';

import path from 'path';

import { useTranslation } from 'react-i18next';

import { pagePathSegments } from '~constants';
import { UserRoleEnum } from '~enums';
import KeysListType from '~features/keys/interfaces/keysListType';
import useAuthorize from '~hooks/useAuthorize';
import PageLayout from '~layouts/page/pageLayout';

import KeysOverviewContainer from '../containers/keysOverviewContainer';
import { SelectedKeysProvider } from '../providers/selectedKeysProvider';

interface KeysPageProps {
	keysListType: KeysListType;
}

const KeysPage = ({ keysListType }: KeysPageProps) => {
	const { t } = useTranslation('entities');
	const authorize = useAuthorize();

	let listType = keysListType;
	// When we're super admin we'll load the internal endpoint down the line
	if (
		listType == 'assigned' &&
		authorize.authorize([UserRoleEnum.SuperAdmin, UserRoleEnum.Support])
	) {
		listType = 'assignedInternal';
	}

	const tabs = useMemo(
		() => [
			{
				key: pagePathSegments.Assigned,
				// TODO: Temporary solution, because now we can't show assigned keys
				// { title: t('assigned', { ns: 'status' }),
				title: t('general.all', { ns: 'entities' }),
				path: path.join('/', pagePathSegments.Keys, pagePathSegments.Assigned),
				component: <KeysOverviewContainer keysListType={listType} />,
			},
			{
				key: pagePathSegments.Unassigned,
				title: t('unassigned', { ns: 'status' }),
				path: path.join('/', pagePathSegments.Keys, pagePathSegments.Unassigned),
				allowedRoles: [UserRoleEnum.SuperAdmin, UserRoleEnum.Support],
				component: (
					<SelectedKeysProvider>
						<KeysOverviewContainer keysListType={listType} />
					</SelectedKeysProvider>
				),
			},
		],
		[listType]
	);

	return (
		<PageLayout
			pageTitle={t('key.labels.plural')}
			headerInfo={{
				title: t('key.labels.plural'),
			}}
			tabs={tabs}
			activeTabKey={keysListType}
		/>
	);
};

export default KeysPage;
